/**
 * @generated SignedSource<<9054d02ef7218e3ba5aeaa2c331e5816>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoLink_linkData$data = {
  readonly path: string | null;
  readonly isLinkable: boolean | null;
  readonly " $fragmentType": "SeoLink_linkData";
};
export type SeoLink_linkData$key = {
  readonly " $data"?: SeoLink_linkData$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoLink_linkData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};

(node as any).hash = "55a81d229ac5e2ca87225e8d0dbdd2a0";

export default node;
